import axios from 'axios'

const baseUrl = 'http://srv.detran.pi.gov.br/renach/detran-agendamento-api'

const consultarCnhEmitida = (cpf, data_nascimento) => {
    return axios.get(`${ baseUrl }/emissaocnh/consultar.php?cpf=${ cpf }&data_nascimento=${ data_nascimento }`, {
        headers: { 'Authorization': 'Bearer QYUALaT2rebMKPAZk5rxyQ' }
    })
        .then(response => response)
        .catch(err => err.response)
}

export default { consultarCnhEmitida }